// export let baseUrl = 'http://vmworld.1qit.com/'
export let baseUrl = 'https://world.jlwmck.com'